
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * TradingCentralTimeFrame enum
 */
class TradingCentralTimeFrame {
  /**
   * Initialize enum with a given value
   * @param {TradingCentralTimeFrame|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof TradingCentralTimeFrame) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!TradingCentralTimeFrame}
   * @param {!TradingCentralTimeFrame} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingCentralTimeFrame)) {
      throw new TypeError('Instance of TradingCentralTimeFrame is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!TradingCentralTimeFrame}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!TradingCentralTimeFrame}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === TradingCentralTimeFrame.DAY_1.value) {
      return 'DAY_1'
    }
    if (this.value === TradingCentralTimeFrame.DAY_7.value) {
      return 'DAY_7'
    }
    if (this.value === TradingCentralTimeFrame.DAY_30.value) {
      return 'DAY_30'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!TradingCentralTimeFrame}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!TradingCentralTimeFrame}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!TradingCentralTimeFrame} Created enum
   */
  static fromObject (other) {
    return new TradingCentralTimeFrame(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
TradingCentralTimeFrame.DAY_1 = new TradingCentralTimeFrame(0 + 0)
// noinspection PointlessArithmeticExpressionJS
TradingCentralTimeFrame.DAY_7 = new TradingCentralTimeFrame(0 + 1)
// noinspection PointlessArithmeticExpressionJS
TradingCentralTimeFrame.DAY_30 = new TradingCentralTimeFrame(0 + 2)

export { TradingCentralTimeFrame };

/**
 * Fast Binary Encoding TradingCentralTimeFrame field model
 */
class FieldModelTradingCentralTimeFrame extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelTradingCentralTimeFrame}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelTradingCentralTimeFrame}
   * @param {TradingCentralTimeFrame=} defaults Default value, defaults is new TradingCentralTimeFrame()
   * @returns {!TradingCentralTimeFrame} Result value
   */
  get (defaults = new TradingCentralTimeFrame()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new TradingCentralTimeFrame(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelTradingCentralTimeFrame}
   * @param {!TradingCentralTimeFrame} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelTradingCentralTimeFrame };
